import React from "react";
import EmptyData from "./EmptyData";

export default function VehicleModal({
  show,
  loading,
  vehicles,
  error,
  onClose,
  onSelectVehicle,
}) {
  if (!show) return null;

  const isActiveContract = (status) => {
    const normalizedStatus = String(status || "").trim().toLowerCase();
    return normalizedStatus === "ativo";
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Selecionar Veiculo</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            <div className="modal-body">
              {error ? <div className="alert alert-danger">{error}</div> : null}

              {loading ? (
                <div className="d-flex justify-content-center p-4">
                  <div className="spinner-border text-primary" role="status" />
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th>Placa</th>
                        <th>Apelido</th>
                        <th>Nome cliente</th>
                        <th>Razao social</th>
                        <th>Status contrato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicles.length ? (
                        vehicles.map((vehicle) => (
                          <tr
                            key={vehicle.id}
                            role="button"
                            onClick={() => onSelectVehicle(vehicle)}
                          >
                            <td>{vehicle.plate}</td>
                            <td>{vehicle.nickname}</td>
                            <td>{vehicle.clientName}</td>
                            <td>{vehicle.companyName}</td>
                            <td>
                              <span
                                className={`badge ${
                                  isActiveContract(vehicle.contractStatus)
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {vehicle.contractStatus}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="py-4">
                            <EmptyData />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
